import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type ResetPasswordState = {
  loading: boolean;
  error: boolean;
  errorMessage: string | null;
  success: boolean;
  data: unknown | null;
};

const initialState: ResetPasswordState = {
  loading: false,
  error: false,
  errorMessage: null,
  success: false,
  data: null,
};

interface ResetPasswordPayload {
  token: string;
  newPassword: string;
}

export const resetPassword = createAsyncThunk<
  unknown,
  ResetPasswordPayload,
  { rejectValue: string }
>('resetPassword', async (payload, thunkAPI) => {
  try {
    const { data } = await api.post('/api/account/reset-password', {
      token: payload.token,
      new_password: payload.newPassword,
    });
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      'Failed to reset password';
    return thunkAPI.rejectWithValue(message);
  }
});

const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
    resetResetPassword: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPassword.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = null;
      state.success = false;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload ?? 'Failed to reset password';
    });
  },
});

export const { resetResetPassword } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
